import { Printer } from "lucide-react";
import { openFile } from "@/lib/files";

/** A big, plain button at the top of the tablet's staff area: print the emergency roll (parent and emergency phone numbers, allergies, a box to tick each child). */
export function PrintRollButton({ api }) {
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-[var(--hp-border)] bg-[var(--hp-card)] px-4 py-3" data-testid="kiosk-paper-roll">
      <Printer className="h-5 w-5 text-[var(--hp-profit)]" />
      <div className="min-w-[200px] flex-1"><p className="text-sm font-semibold text-[var(--hp-heading)]">Emergency paper roll</p><p className="text-xs text-[var(--hp-muted)]">Who is expected today, who to ring, and what each child needs. Keep a copy by the door.</p></div>
      <button data-testid="kiosk-print-roll" onClick={() => openFile(`${api}/kiosk/paper-roll`)} className="inline-flex items-center gap-1.5 rounded-full bg-[var(--hp-primary)] px-4 py-2 text-xs font-bold text-[#04231a]"><Printer className="h-3.5 w-3.5" /> Print the roll</button>
    </div>
  );
}
